import { tsUtils } from '@neo-one/ts-utils';
export const hasSymbol = (context, node, type) => tsUtils.type_.hasType(type, (tpe) => isSymbol(context, node, tpe));
export const isOnlySymbol = (context, node, type) => tsUtils.type_.isOnlyType(type, (tpe) => isSymbol(context, node, tpe));
export const isSymbol = (_context, _node, type) => tsUtils.type_.isSymbolish(type);

//# sourceMappingURL=typeTests.js.map
